/**
 * Deposit Verification Agent: API client for the buyer's earnest-money
 * escrow receipt, uploaded (PDF) once the seller accepts the offer.
 */
import { API_BASE_URL } from './apiAgent';

class DepositVerificationAgent {
  /** Upload the escrow receipt PDF for an accepted offer. */
  static async uploadDocument(offerId, {
    file,
    documentType,
    attestedBalance,
    attestedStatementDate,
    buyerNotes,
  }) {
    if (!file) throw new Error('A PDF file is required');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('document_type', documentType);
    if (attestedBalance !== undefined && attestedBalance !== null && attestedBalance !== '') {
      formData.append('attested_balance', String(attestedBalance));
    }
    if (attestedStatementDate) {
      formData.append('attested_statement_date', attestedStatementDate);
    }
    if (buyerNotes) {
      formData.append('buyer_notes', buyerNotes);
    }

    const response = await fetch(
      `${API_BASE_URL}/api/offers/${offerId}/deposit-verification`,
      { method: 'POST', credentials: 'include', body: formData }
    );
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.detail || `Upload failed: ${response.status}`);
    }
    return response.json();
  }

  /** Fetch the verification record metadata for an offer. */
  static async get(offerId) {
    const response = await fetch(
      `${API_BASE_URL}/api/offers/${offerId}/deposit-verification`,
      { credentials: 'include' }
    );
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.detail || `Fetch failed: ${response.status}`);
    }
    return response.json();
  }

  /** Direct download URL for the document PDF (auth via cookie). */
  static getDownloadUrl(offerId) {
    return `${API_BASE_URL}/api/offers/${offerId}/deposit-verification/file`;
  }
}

export default DepositVerificationAgent;
